import { put } from 'redux-saga/effects'
import { setFilterValue } from '../../actions/filtersActions';

function* removeGenericFilter(key, value){
    yield put(setFilterValue(key, value))
}

export { removeGenericFilter }